import './page.module.scss'

import React from 'react'
import { IconsBundle } from 'src/components/icons/icons-bundle'
import { Head } from 'src/components/meta/head'
import { Schemas } from 'src/components/meta/schemas'
import { Breadcrumbs } from 'src/components/page/layout/breadcrumbs'
import { Footer } from 'src/components/page/layout/footer'
import { Header } from 'src/components/page/layout/header'
import { Sidebar } from 'src/components/page/layout/sidebar'

export const Page: React.FC = ({ children }) => {
  return (
    <>
      <Head />
      <Sidebar />
      <Header />
      <Breadcrumbs />
      {children}
      <Footer />
      <Schemas />
      <IconsBundle />
    </>
  )
}
